import React from 'react'
import Title from '../Shared/Title/Title'
import * as styles from './productCard.module.scss'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import { useDictionaryQuery } from '../../fragments/hooks/useDictionaryQuery'
const ProductCard = ({ gridItems }) => {
    const { products, mainTitle, title, otherPages, headingLevel } = gridItems
    const {explore} = useDictionaryQuery()
    return (
        <div className='container container-lg'>
            {title && <div className={styles.title}><Title title = {title} headingLevel = {headingLevel}/></div>}
            <div className={` ${styles.cardWrapper}`}>
                {
                    products && products.map((card, id) => {
                        const { slug, thumbnailImage, thumbnailTitle } = card
                        return (
                            <Link to={slug} className={styles.card} key={id}>
                                <div>
                                    <GatsbyImage
                                        image={thumbnailImage.gatsbyImageData}
                                        alt={`${thumbnailImage.title} image`}
                                        loading="lazy"
                                    />
                                </div>
                                <div className={styles.cardTitle}> {thumbnailTitle} </div>
                                <button className={`red-button ${styles.cta}`}>{explore}</button>
                            </Link>
                        )
                    })
                }
                {
                    otherPages && otherPages.map((card, id) => {
                        const { slug, thumbnailImage, thumbnailTitle } = card
                        return (
                            <Link to={slug} className={styles.card} key={id}>
                                <div>
                                    <GatsbyImage
                                        image={thumbnailImage.gatsbyImageData}
                                        alt={`${thumbnailImage.title} image`}
                                        loading="lazy"
                                    />
                                </div>
                                <div className={styles.cardTitle}> {thumbnailTitle} </div>
                                <button className={`red-button ${styles.cta}`}>EXPLORE +</button>
                            </Link>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default ProductCard